import React from 'react';
import './hero.css';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import PlaceIcon from '@mui/icons-material/PlaceOutlined';
import SocialLinks from '../SocialLinks/SocialLinks';
import portrait from '../image/portrait.png';
import { contact, profile } from '../../data/profile';

// Staggered mount animation — each block enters slightly after the one above it.
const rise = (delay) => ({ animationDelay: `${delay}ms` });

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-inner container">
        <div className="hero-copy">
          <p className="hero-greeting rise" style={rise(0)}>
            <span className="hero-wave" role="img" aria-label="waving hand">
              👋
            </span>
            Hi, I&apos;m
          </p>

          <h1 className="hero-name rise" style={rise(80)}>
            {profile.name}
          </h1>

          <p className="hero-headline rise" style={rise(160)}>
            {profile.headline}
          </p>

          <p className="hero-tagline rise" style={rise(240)}>
            {profile.tagline}
          </p>

          <p className="hero-meta rise" style={rise(320)}>
            <PlaceIcon fontSize="small" />
            {profile.location}
            <span className="hero-dot" aria-hidden="true">
              ·
            </span>
            {profile.role} at {profile.company}
          </p>

          <div className="hero-actions rise" style={rise(400)}>
            <a className="btn btn--primary" href="#contact">
              Get in touch
            </a>
            <a
              className="btn btn--ghost"
              href={contact.blog}
              target="_blank"
              rel="noreferrer"
            >
              Visit my blog
              <ArrowOutwardIcon fontSize="small" />
            </a>
          </div>

          <SocialLinks className="hero-socials rise" style={rise(480)} />
        </div>

        <div className="hero-portrait rise" style={rise(200)}>
          <div className="hero-portrait-frame">
            <img src={portrait} alt={`Portrait of ${profile.name}`} />
          </div>
        </div>
      </div>

      <a className="hero-scroll" href="#about" aria-label="Scroll to about section">
        <span className="hero-scroll-line" aria-hidden="true" />
        Scroll
      </a>
    </section>
  );
}

export default Hero;
